const nameSpace = 'account'

export const actions = {
  GET_SYSTEM_OWNER: `${nameSpace}/GET_SYSTEM_OWNER`,
}

export const getters = {
  systemOwner: `${nameSpace}/systemOwner`,
  isAdvertiser: `${nameSpace}/isAdvertiser`,
  isSuperAdmin: `${nameSpace}/isSuperAdmin`,
}
